import React, { Fragment } from 'react'
import classnames from 'classnames'

import { useFloorState } from '../../firebase/hooks/useFloor'
import { useHumanParticipants } from '../../webrtc/webRTCRoom'
import useFeatures from '../../sharedLegacy/hooks/useFeatures'

import { FloorCameraFeed } from './FloorFeed/FloorCameraFeed/FloorCameraFeed'
import { FloorMobileFeed } from './FloorFeed/FloorMobileFeed/FloorMobileFeed'
import { FloorScreenFeed } from './FloorFeed/FloorScreenFeed/FloorScreenFeed'
import { FloorTrayFeed } from './FloorFeed/FloorTrayFeed/FloorTrayFeed'

import './floor.scss'

const Floor = () => {
  const floor = useFloorState()
  const participants = useHumanParticipants().toSorted(
    (a, b) => a.joinedAt - b.joinedAt
  )

  const { HasTransitionsEnabled } = useFeatures()

  if (!floor) return null

  const identifier = 'identifier' in floor ? floor.identifier : undefined

  return (
    <div
      className={classnames('floor', {
        'transitions-enabled': HasTransitionsEnabled,
      })}
      data-layout={floor.layout}
      data-identifier={identifier}
    >
      {participants.map((participant) => (
        <Fragment key={participant.id}>
          <FloorCameraFeed id={participant.id} />
          <FloorScreenFeed id={participant.id} />
          <FloorMobileFeed id={participant.id} />
        </Fragment>
      ))}
      <FloorTrayFeed />
    </div>
  )
}

export default Floor
